webpackJsonp([35783957827783],{

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(4);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _config = __webpack_require__(19);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(401);
	
	var degreesToMouse = function degreesToMouse(mouseEvent, image) {
	  var rect = image.getBoundingClientRect();
	  var left = rect.left + window.scrollX;
	  var top = rect.top + window.scrollY;
	  var x = mouseEvent.pageX - left - image.offsetWidth / 2;
	  var y = mouseEvent.pageY - top - image.offsetHeight / 2;
	  var rads = Math.atan2(y, x) + Math.PI;
	  var degree = rads / (Math.PI / 180);
	  return degree;
	};
	
	var lookingDirection = function lookingDirection(degrees) {
	  if (degrees > 340 || degrees < 20) {
	    return -1; // Left
	  }
	  if (degrees > 20 && degrees < 70) {
	    return -8; // Up and Left
	  }
	  if (degrees > 70 && degrees < 110) {
	    return -7; // Up
	  }
	  if (degrees > 110 && degrees < 160) {
	    return -6; // Up and Right
	  }
	  if (degrees > 160 && degrees < 200) {
	    return -5; // Right
	  }
	  if (degrees > 200 && degrees < 250) {
	    return -4; // Down and Right
	  }
	  if (degrees > 250 && degrees < 290) {
	    return -3; // Down
	  }
	  if (degrees > 290 && degrees < 340) {
	    return -2; // Down and Left
	  }
	};
	
	var Bio = function (_React$Component) {
	  _inherits(Bio, _React$Component);
	
	  function Bio(props) {
	    _classCallCheck(this, Bio);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.mouseMove = function (event) {
	      if (_this.profileRef.current) {
	        var degrees = degreesToMouse(event, _this.profileRef.current);
	        var direction = lookingDirection(degrees);
	        if (direction !== _this.state.direction) {
	          _this.setState({
	            direction: direction
	          });
	        }
	      }
	    };
	
	    _this.onHoverImage = function () {
	      _this.setState({
	        hover: true
	      });
	    };
	
	    _this.onBlurImage = function () {
	      _this.setState({
	        hover: false
	      });
	    };
	
	    _this.profileRef = _react2.default.createRef();
	    _this.state = {
	      direction: null,
	      hover: false
	      // Hack, get us past the build stage.
	    };if (typeof window !== 'undefined') {
	      window.addEventListener('mousemove', _this.mouseMove);
	    }
	    return _this;
	  }
	
	  Bio.prototype.render = function render() {
	    var backgroundPosition = void 0;
	    if (this.state.direction && this.profileRef.current) {
	      if (this.state.hover) {
	        backgroundPosition = '0 0';
	      } else {
	        var width = this.profileRef.current.offsetWidth;
	        backgroundPosition = '0 ' + this.state.direction * width + 'px';
	      }
	    }
	    var content = void 0;
	    if (this.props.full) {
	      content = _react2.default.createElement(
	        'p',
	        { style: { marginBottom: 0 } },
	        'Written by ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Cameron Maske'
	        ),
	        '.',
	        _react2.default.createElement('br', null),
	        'Are you a Python Developer? I\'m working on a',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: _config2.default.courses.pytest.path },
	          'course about testing with Python with pytest'
	        ),
	        ' ',
	        'and if you have a spare 5 minutes, I would love to hear about your',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          {
	            target: '_blank',
	            rel: 'noopener',
	            href: 'https://goo.gl/forms/1CwGmWboTnjEzgFi1'
	          },
	          'experiences'
	        ),
	        '. ',
	        _react2.default.createElement('br', null),
	        'Want to get in touch? Feel free to drop me an',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', rel: 'noopener', href: 'mailto:c@meronmaske.com' },
	          ' ',
	          'email'
	        ),
	        ' ',
	        'or over on',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          {
	            target: '_blank',
	            rel: 'noopener',
	            href: 'http://www.twitter.com/cameronmaske/'
	          },
	          'twitter'
	        ),
	        '.'
	      );
	    } else {
	      content = _react2.default.createElement(
	        'p',
	        { style: { marginBottom: 0, textAlign: 'center' } },
	        'Are you a Python Developer? I\'m working on a',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: _config2.default.courses.pytest.path },
	          'course about testing with pytest'
	        ),
	        ' ',
	        'and if you have a spare 5 minutes, I would love to hear about your',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          {
	            target: '_blank',
	            rel: 'noopener',
	            href: 'https://goo.gl/forms/1CwGmWboTnjEzgFi1'
	          },
	          'experiences'
	        ),
	        '.'
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          display: 'flex',
	          marginBottom: (0, _typography.rhythm)(1),
	          alignItems: 'center',
	          width: '100%'
	        }
	      },
	      _react2.default.createElement('div', {
	        ref: this.profileRef,
	        className: 'bio',
	        alt: 'Cameron Maske',
	        onMouseEnter: this.onHoverImage,
	        onMouseLeave: this.onBlurImage,
	        style: {
	          marginRight: (0, _typography.rhythm)(1 / 2),
	          backgroundPosition: backgroundPosition
	        }
	      }),
	      content
	    );
	  };
	
	  return Bio;
	}(_react2.default.Component);
	
	exports.default = Bio;
	module.exports = exports['default'];

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(32);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Navbar = __webpack_require__(324);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(_Navbar2.default, null),
	    children
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(344);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _SEO = __webpack_require__(323);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Bio = __webpack_require__(347);
	
	var _Bio2 = _interopRequireDefault(_Bio);
	
	var _HomeLayout = __webpack_require__(350);
	
	var _HomeLayout2 = _interopRequireDefault(_HomeLayout);
	
	var _typography = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogIndex.prototype.render = function render() {
	    var siteUrl = (0, _get2.default)(this, 'props.data.site.siteMetadata.siteUrl');
	    var siteTitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.title');
	    var posts = (0, _get2.default)(this, 'props.data.allMarkdownRemark.edges');
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _HomeLayout2.default,
	        null,
	        _react2.default.createElement(_SEO2.default, { title: siteTitle, url: siteUrl }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: (0, _typography.rhythm)(1) } },
	          _react2.default.createElement(_Bio2.default, null)
	        ),
	        posts.map(function (_ref) {
	          var node = _ref.node;
	
	          var title = (0, _get2.default)(node, 'frontmatter.title') || node.fields.slug;
	          var intro = (0, _get2.default)(node, 'frontmatter.intro') || node.excerpt;
	          return _react2.default.createElement(
	            'div',
	            { key: node.fields.slug },
	            _react2.default.createElement(
	              'h3',
	              {
	                style: {
	                  marginBottom: (0, _typography.rhythm)(1 / 4)
	                }
	              },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { style: { boxShadow: 'none' }, to: node.fields.slug },
	                title
	              )
	            ),
	            _react2.default.createElement(
	              'small',
	              null,
	              node.frontmatter.date,
	              ' \xB7 ',
	              node.frontmatter.tags
	            ),
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: intro } })
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Side Projects'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'unlisted' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://closedlooplabs.com' },
	                'Noise Blocker'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://tryoutglasses.com' },
	                'Try Out Glasses'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	exports.default = BlogIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-89448768c8bb956fd97f.js